export const getShortId = (id) => {
  return id ? id.substring(0, 10).toUpperCase() : "-";
};
